import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import { TRACKING_QUERY_PARAMS } from '../../utils/Constants';
import { useQuery } from '../../routes';

export const useTrackCookie = () => {
  const { get } = useQuery();
  const [, setCookie] = useCookies(TRACKING_QUERY_PARAMS);

  useEffect(() => {
    TRACKING_QUERY_PARAMS.forEach(param => {
      const value = get(param);
      if (value) {
        setCookie(param, value);
      }
    });
  }, []);
};
